import Vue from "vue";
import VueRouter from "vue-router";
import { jwtDecode } from "jwt-decode";

Vue.use(VueRouter);

const routeModules = require.context("./groups", true, /routes\.js$/);
const routes = [];

routeModules.keys().forEach((fileName) => {
  const routeModule = routeModules(fileName).default;
  routes.push(...routeModule);
});

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  const userData = localStorage.getItem("userData");
  let userLevel = null;

  if (userData) {
    try {
      const userAccess = JSON.parse(userData);
      const decodedToken = jwtDecode(userAccess.token);
      const now = Math.floor(Date.now() / 1000);

      if (decodedToken.exp && decodedToken.exp > now) {
        userLevel = decodedToken.level
          ? decodedToken.level
          : [decodedToken.level];
      } else {
        console.warn("Token expired");
        localStorage.removeItem("userData");
        return next("/login");
      }
    } catch (err) {
      console.error("Invalid token:", err);
      localStorage.removeItem("userData");
      return next("/login");
    }
  }

  const requiredLevel = to.meta?.requiredLevel;

  if (to.meta.requiresOTP && !localStorage.getItem("otpPending")) {
    console.log("OTP not verified, redirecting to OTP verification");
    return next("/two-factor-auth"); // Redirect to OTP page if OTP is not pending
  } else if (
    to.path !== "/" &&
    to.path !== "/login" &&
    to.path !== "/forgot-password" &&
    to.path !== "/reset-password" &&
    to.path !== "/two-factor-auth" &&
    !userData
  ) {
    next("/login");
  } else if (to.path === "/login" && userData) {
    next("/dashboard");
  } else if (requiredLevel && userLevel && userLevel !== requiredLevel) {
    if (!requiredLevel.includes(userLevel)) {
      next("/forbidden");
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
